export const SUBSCRIBER_CONSTS = {
    GET_SUBSCRIBERS: "GET_SUBSCRIBERS",
    DELETE_SUBSCRIBER_BY_ID: "DELETE_SUBSCRIBER_BY_ID",
    SEND_SUBSCRIBERS: "SEND_SUBSCRIBERS",
};
